import { SplashScreen } from '@capacitor/splash-screen'

/**
 * Ein Plugin zur Registrierung von Hook-Listeners
 */
export default defineNuxtPlugin((nuxtApp) => {
	const { ready, refresh } = useApp()
	const { ensureExistsInDatabase } = useAccount()
	const { clearSelection } = useAssociations()

	nuxtApp.hook('auth:logout', () => {
		clearSelection()
	})

	nuxtApp.hook('auth:authenticated', async () => {
		await ensureExistsInDatabase()
		await refresh()
	})

	nuxtApp.hook('page:loading:start', async () => {
		/**
		 * Wenn die App mit einem Keycloak-Hash in der URL gestartet wird (z.B. nach einer DOI),
		 * dann soll in die Mobile-App umgeleitet werden.
		 */
		if (window.location.hash.includes('keycloak')) {
			if (isPlatform('mobile')) {
				window.location.href = useRuntimeConfig().public.keycloak.appRedirectUri
			}
		}
	})

	nuxtApp.hook('app:created', async () => {
		// TODO: Workaround für iOS 26: Die untere Hälfte des Bildschirms wird gefärbt, damit das Keyboard nicht abgeschnitten wirkt
		if (isPlatform('capacitor')) {
			const gradient = 'linear-gradient(to bottom, #000000 0%, #000000 50%, #FFFFFF 50%, #FFFFFF 100%)'
			document.documentElement.style.background = gradient
			document.body.style.background = gradient
			document.querySelector('ion-app')?.setAttribute('style', `background: ${gradient}`)
		}

		try {
			await refresh() // Refresh ist hier im Sinne der Initialisierung
			ready.value = true
		} catch (error) {
			console.error('Error during app initialization', error)

			// Error will be automatically captured by app:error hook
			throw createError({
				statusCode: 500,
				cause: error,
				statusMessage: 'Error during app initialization',
				fatal: true,
			})
		} finally {
			// Splash Screen ausblenden, wenn die App bereit ist
			await SplashScreen.hide()
		}
	})
})
